export default "__VITE_ASSET__8d4d2b79__"